


















import Vue from 'vue'
import { GetterSetter } from 'vue/types/vue'

export default Vue.extend({
  props: {
    showDialog: Boolean
  },
  computed: {
    dialogActive: {
      get () { return !!this.showDialog },
      set (show: boolean) {
        return show
      }
    } as GetterSetter<boolean>
  },
  methods: {
    dialogClosed (): void {
      this.$emit('dialog-closed')
    }
  }
})
